import { render, staticRenderFns } from "./RegionDetailView.vue?vue&type=template&id=53a47de4&scoped=true"
import script from "./RegionDetailView.vue?vue&type=script&lang=js"
export * from "./RegionDetailView.vue?vue&type=script&lang=js"
import style0 from "./RegionDetailView.vue?vue&type=style&index=0&id=53a47de4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a47de4",
  null
  
)

export default component.exports